import React from 'react';
import SDKLivenessForm from './SDKLivenessForm';


class SDKLivenessCreate extends React.Component {

    validateFields = (values,config)=>{
        this.form && this.form.validateFields(values,config);
    }
    render(){
        return (
            <div>
                <SDKLivenessForm validateFields={this.validateFields} ref={(form)=>this.form=form}/>
            </div>
        );
    }

}
export default SDKLivenessCreate;



// WEBPACK FOOTER //
// ./src/pages/SDKLiveness/SDKLivenessCreate.js